module.exports = __webpack_public_path__ + "img/az_haohuotong_logo.2e7ef8ac.png";